import axios from 'axios';

/**
 * 获取客服二维码
 * 注意：此接口使用不同的 baseURL (https://wecom.wzxn.top/)
 */
export function getServiceQrcode() {
    return axios({
        url: 'https://wecom.wzxn.top/qrcode/get_service_qrcode',
        method: 'get',
    }).then(response => response.data);
}
